import { COMPANY_STATUS } from "shared/enums/common.enum";
import { Subscription } from "../packages/subscription";

export class Company {
    id!: string
    name!: string;
    companyEmail!: string
    createdAt!: string
    updatedAt!: string
    status!: COMPANY_STATUS
    currentSubscription: CurrentSubscription | null = null;
    adminEmail!: string;
    totalSpending!: number;
    currentUsers: number = 0;
    currentWarehouses: number = 0;
    ambassadorCode: string | null = null;
    ambassadorName: string | null = null;
    hasPurchasedSubscription: boolean = false;
    constructor(data: Partial<Company> = {}) {
        Object.assign(this, data);
        if(data.currentSubscription) this.currentSubscription = new CurrentSubscription(this.currentSubscription ?? {});
    }
}

export class CurrentSubscription {
    id!: string;
    isTrial: boolean = false;
    startDate!: string
    endDate!: string
    subscription !: Subscription;
    additionalWarehouses!: number;
    additionalUsers !: number;
    trialEndDate!: string;
    trialStartDate!: string;
    constructor(data: Partial<CurrentSubscription> = {}) {
        Object.assign(this, data);
        this.subscription = new Subscription(this.subscription ?? {});
    }
}
